import { atom, selector } from "recoil";
import { Vector3 } from "features/morphing/state/parameterAtoms";

export interface AppConfig {
  name: string;
  studyName: string;
  nParallels: number;
  nTrials: number;
  minDesignSpace: Vector3;
  maxDesignSpace: Vector3;
}

export const appConfigState = atom<AppConfig>({
  key: 'appConfigState',
  default: {
    name: 'cd_0deg',
    studyName: '',
    nParallels: 1,
    nTrials: 1,
    minDesignSpace: { x: 0, y: 0, z: 0 },
    maxDesignSpace: { x: 0, y: 0, z: 0 },
  }
});

// `name`プロパティに対するRecoilState
export const appNameState = selector<string>({
  key: 'appNameState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.name;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      name: newValue as string,
    });
  },
});

// `studyName`プロパティに対するRecoilState
export const studyNameState = selector<string>({
  key: 'studyNameState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.studyName;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      studyName: newValue as string,
    });
  },
});

// `nParallels`プロパティに対するRecoilState
export const nParallelsState = selector<number>({
  key: 'nParallelsState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.nParallels;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      nParallels: newValue as number,
    });
  },
});

// `nTrials`プロパティに対するRecoilState
export const nTrialsState = selector<number>({
  key: 'nTrialsState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.nTrials;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      nTrials: newValue as number,
    });
  },
});

// `minDesignSpace`プロパティに対するRecoilState
export const minDesignSpaceState = selector<Vector3>({
  key: 'minDesignSpaceState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.minDesignSpace;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      minDesignSpace: newValue as Vector3,
    });
  },
});

// `maxDesignSpace`プロパティに対するRecoilState
export const maxDesignSpaceState = selector<Vector3>({
  key: 'maxDesignSpaceState',
  get: ({ get }) => {
    const appConfig = get(appConfigState);
    return appConfig.maxDesignSpace;
  },
  set: ({ get, set }, newValue) => {
    const appConfig = get(appConfigState);
    set(appConfigState, {
      ...appConfig,
      maxDesignSpace: newValue as Vector3,
    });
  },
});
